import { Card, Col, Row } from 'react-bootstrap';
import Flex from '@/components/common/Flex';

const TITLE_WIDTHS = ['68%', '78%', '58%', '72%', '64%', '80%'];
const DESC_WIDTHS = [
  ['96%', '88%', '72%'],
  ['92%', '84%', '60%'],
  ['98%', '76%', '68%'],
  ['90%', '82%', '55%'],
  ['94%', '70%', '78%'],
  ['88%', '86%', '62%']
];
const META_WIDTHS = [
  [88, 72],
  [96, 64],
  [80, 84],
  [104, 70],
  [76, 92],
  [90, 66]
];

type McpPromptsListPreloadProps = {
  cards?: number;
};

/** Skeleton grid matching prompt template cards on `/chat/prompts`. */
export function McpPromptsListPreload({ cards = 6 }: McpPromptsListPreloadProps) {
  return (
    <Row className="g-3 mb-3 placeholder-glow" aria-hidden>
      {Array.from({ length: cards }, (_, index) => {
        const desc = DESC_WIDTHS[index % DESC_WIDTHS.length];
        const meta = META_WIDTHS[index % META_WIDTHS.length];
        return (
          <Col key={index} xs={12} md={6} xl={4}>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column p-3">
                <Flex
                  alignItems="start"
                  justifyContent="between"
                  className="gap-2 mb-2"
                >
                  <span
                    className="placeholder rounded"
                    style={{
                      width: TITLE_WIDTHS[index % TITLE_WIDTHS.length],
                      height: 14
                    }}
                  />
                  <span
                    className="placeholder rounded flex-shrink-0"
                    style={{ width: 56, height: 28 }}
                  />
                </Flex>

                <div className="mb-2 flex-grow-1">
                  {desc.map((width, line) => (
                    <span
                      key={line}
                      className="placeholder rounded d-block mb-2"
                      style={{ width, height: 11 }}
                    />
                  ))}
                </div>

                <div className="mt-auto">
                  <span
                    className="placeholder rounded d-block mb-2"
                    style={{ width: meta[0], height: 10 }}
                  />
                  <span
                    className="placeholder rounded d-block"
                    style={{ width: meta[1], height: 10 }}
                  />
                </div>
              </Card.Body>

              <Card.Footer className="bg-body-tertiary border-top py-2 px-3">
                <Flex
                  alignItems="center"
                  justifyContent="between"
                  className="gap-2"
                >
                  <Flex alignItems="center" className="gap-2">
                    <span
                      className="placeholder rounded"
                      style={{ width: 42, height: 12 }}
                    />
                    <span
                      className="placeholder rounded"
                      style={{ width: 88, height: 12 }}
                    />
                  </Flex>
                  <Flex alignItems="center" className="gap-2">
                    <span
                      className="placeholder rounded"
                      style={{ width: 48, height: 28 }}
                    />
                    <span
                      className="placeholder rounded"
                      style={{ width: 110, height: 28 }}
                    />
                  </Flex>
                </Flex>
              </Card.Footer>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
